import { Box } from '../../Box';
import { idBuilder } from '../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
const resolvePadding = (usePadding, hasHeader) => {
  if (!usePadding) {
    return '0';
  }
  if (hasHeader) {
    return '0 16px 16px 16px';
  }
  return '16px 16px 16px 16px';
};
const contentStyle = (usePadding, hasHeader) => ({
  padding: resolvePadding(usePadding, hasHeader)
});
export const PopoverContent = props => {
  const {
    children,
    usePadding,
    id,
    hasHeader,
    ...rest
  } = props;
  return /*#__PURE__*/_jsx(Box, {
    sx: contentStyle(usePadding, hasHeader),
    className: 'ids-popover-content',
    id: idBuilder('ids-popover-content', id),
    "data-testid": idBuilder('ids-popover-content', rest['data-testid']),
    children: children
  });
};